import React from "react";
import "./Button.css";

function Button({ onClick, label, disabled }) {
  return (
    <button 
      className="custom-button" 
      onClick={onClick} 
      disabled={disabled}
    >
      {label}
    </button>
  );
}

export default Button;